import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router";
import TopBarProgress from "react-topbar-progress-indicator";
import { createSearchParams } from "react-router-dom";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";

import {
  getCustomFilterById, deleteGlobalCustomFilterValue
} from "../../../actions/filters";

import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import { CircularProgress } from "@mui/material";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import DeleteConfirmationDialog, {
  confirmButtonType,
} from "../../../components/dialog-boxes/delete-confirmation-dialog";
import StatusButton from "../CreateFilters/Components/StatusButton";
import FilterSortDrawer from "../CreateFilters/Components/FilterDrawer";
import UpdateSequence from "./Components/UpdateSequence";
import { HiMiniArrowsUpDown } from "react-icons/hi2";

const GlobalCustomFilterDetails = () => {
  // hooks
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // Local State
  const [isMount, setisMount] = useState(false);
  const [loading, setloading] = useState(true);
  const [globalCustomFilter, setGlobalCustomFilter] = useState({});
  const [productAttributes, setproductAttributes] = useState([]);
  const [attribute, setAttribute] = useState('')
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [SearchFilterr, setSearchFilterr] = useState({
    title: "",
  });
  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });
  const [InnderLoader, setInnderLoader] = useState(false);
  // Api calls for get Order
  const getAttributeDetail = useCallback(
    async (
      id,
      title,
    ) => {
      setloading(true);
      const res = await dispatch(
        getCustomFilterById(id,
          title
        )
      );
      if (res) {
        setGlobalCustomFilter(res?.globalCustomFilter);
        setproductAttributes(res?.productAttribute);
        setAttribute(res?.attribute)
      }
      setloading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    if (id) {
      var timer = setTimeout(() => {
        getAttributeDetail(id, SearchFilterr.title);
      }, 1000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [getAttributeDetail, id, SearchFilterr.title]);


  useEffect(() => {
    if (!Edit.open) {
      var timer = setTimeout(() => {
        getAttributeDetail(id, SearchFilterr.title);
      }, 1000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [Edit.open, getAttributeDetail, id, SearchFilterr.title]);

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({
        page: value,
      })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };
  const handleDeleteConfirm = async (id) => {
    setloading(true);
    const res = await dispatch(deleteGlobalCustomFilterValue(globalCustomFilter._id, id));
    if (res) {
      setdeleteConfirm({
        open: false,
        id: null,
      });
      setisMount(!isMount);
      setloading(false);
    }
  };

  const handleSubmit = () => {
    console.log('hddd')
    navigate(
      `/admin/edit-custom-global-filter-detail/create?attributeId=${attribute._id}`
    )
  }

  const handleSequenceChange = (name, id, sequence, globalCustomFilterId) => {
    setEdit({
      open: true,
      edit: "update-sequence",
      title: name,
      valueId: id,
      sequence: sequence,
      globalCustomFilterId: globalCustomFilterId
    });
  };
  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          {/* <div
        className=" d-flex    justify-content-end align-center flex-wrap"
        style={{ gap: "20px" }}
      >
        <SearchFilter
          type="text"
          placeholder={"Search Name"}
          value={SearchFilterr?.title}
          onChange={(e) =>
            setSearchFilterr({
              ...SearchFilterr,
              title: e.target.value,
            })
          }
        />
     
        
      </div> */}
          <div className="my-1">
            <DashboardPagesLayout
              pageTitle="Global Custom Filters"
              subTitle="items"
              count={globalCustomFilter?.values?.length}
              showBtn={true}
              buttonText="Add New Filter"
              handleSubmit={() => handleSubmit()}
            >
              <div className="dashboard-pages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Position</th>
                      <th>Filter Image</th>
                      <th>Filter Title</th>
                      <th>Filter Description</th>
                      <th>Attribute Selected</th>
                      <th>Parent Attribute</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {globalCustomFilter?.values?.length ? (
                      <>
                        {globalCustomFilter?.values?.map((item, i) => (
                          <tr key={item?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${item?._id}`)
                              }
                            >
                              {i + 1}
                            </td>
                            <td>
                              <StatusButton
                                width={100}
                                status={false}
                                onClick={() => handleSequenceChange(item?.title, item._id, item?.sequence || 0, globalCustomFilter._id)}
                              >
                                {item?.sequence || 0} <HiMiniArrowsUpDown fontSize={20} />

                              </StatusButton>
                            </td>
                            <td>{item.showImage ? <img src={item?.imageURL} alt="Filter" width={30} height={30} /> : ''}</td>
                            <td>{item.title}</td>
                            <td>{item.description}</td>
                            <td>{item.productAttribute?.length}</td>
                            <td>{attribute.name}</td>

                            <td>
                              <CustomeTableBtn
                                color="black"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() =>
                                  navigate(
                                    `/admin/edit-custom-global-filter-detail/${item._id}?attributeId=${attribute._id}`
                                  )
                                }
                              >
                                Edit
                              </CustomeTableBtn>

                              <CustomeTableBtn
                                color="danger"
                                width={"100px"}
                                onClick={() =>
                                  setdeleteConfirm({
                                    open: true,
                                    id: item?._id,
                                  })
                                }
                              >
                                Delete
                              </CustomeTableBtn>




                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            {" "}
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                <FilterSortDrawer
                  Edit={Edit}
                  setEdit={setEdit}
                >
                  {InnderLoader ? (
                    <div className="d-flex align-center justify-content-center">
                      <CircularProgress />
                    </div>
                  ) : (
                    <>

                      {Edit.edit === "update-sequence" && (
                        <>
                          <UpdateSequence edit={Edit} setEdit={setEdit} />
                        </>
                      )}

                    </>
                  )}
                </FilterSortDrawer>
              </div>
              {deleteConfirm.open && (
                <DeleteConfirmationDialog
                  show={true}
                  message="Are you sure you want to delete?"
                  onCancel={() =>
                    setdeleteConfirm({ open: false, id: null })
                  }
                  title="Are you sure?"
                  confirmBtnBsStyle={confirmButtonType.Danger}
                  onConfirm={(e) => {
                    handleDeleteConfirm(deleteConfirm?.id);
                  }}
                  focusCancelBtn={true}
                />
              )}
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default GlobalCustomFilterDetails;
